<template>
  <BranchOfficeSelect
    hint="Sucursal"
    label="Sucursal"
    name="sucursal"
    :value="value"
    :required="required"
    :subhint="subhint"
    :validationError="validationError"
    :scroll-on-focus="scrollOnFocus"
    :analyticsName="'sucursal'"
    :analyticsTypology="config && config.analyticsTypology"
    :quantumObfuscate="quantumObfuscate"
    :options="options"
    :titleFn="titleOld"
    :displayFn="displayOld"
    :zIndex="1"
    @input="$emit('input', $event)"
    @click="$emit('click')"
  />
</template>

<script>
import axios from "axios";
import BranchOfficeSelect from "@/components/core/composite/combos/BranchOfficeSelect";

export default {
  name: "BranchOfficesOld",
  components: { BranchOfficeSelect },
  props: [
    "placeholder",
    "label",
    "value",
    "subhint",
    "validationError",
    "scrollOnFocus",
    "items",
    "inputMode",
    "name",
    "quantumObfuscate",
    "required",
    "config"
  ],
  data() {
    return { sucursales: null };
  },
  computed: {
    options() {
      if (!this.sucursales) return [];
      return this.sucursales.data.data.map(item => ({
        label: item.description || item,
        value: item.id || item,
        provincia: item.address.city || item,
        localidad: item.address.city || item,
        direccion: item.address.addressName || item
      }));
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.sucursales = await axios.get(
        "https://servicios.bbva.com.ar/openmarket/servicios/pois/v0/branches?latitude=-34.6037345&longitude=-58.3837591&radius=5000000&branchType=INTEGRAL"
      );
    },
    titleOld(o) {
      return `${o.value} - ${o.direccion} - ${o.localidad}`;
    },
    displayOld(o) {
      return `${o.value} - ${o.direccion} - ${o.localidad}`;
    }
  }
};
</script>
